const addresses = {
    stakeVault_contract: {
        1: '0x85df8dE41cB3574CA1195dc852B6B148Aa1f42e5', // Ethereum Mainnet
        4: '0x85df8dE41cB3574CA1195dc852B6B148Aa1f42e5', // Rinked TestNet
        5: '0x21fFBA1Bd76eA86FE5943C0d9F2fad7A7B617Dc9', // Goerli TestNet
        137: '0x3f9d125090141E63C9eB09BADfC2adDD2E1C449f', // Polygon MainNet
        80001: '0xa1b4fA17ba7e225A0a1724f4f5D0169f52f5FFc3' // Polygon TestNet
    },
    usdc_token: {
        1: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', // Ethereum Mainnet
        4: '0xeb8f08a975Ab53E34D8a0330E0D34de942C95926', // Rinked TestNet,
        5: '0x7BD32ACC08E790B2d16b8b1B6f3643EFF46504c5', // Goerli TestNet,
        137: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174', // Polygon MainNet,
        80001: '0xe6b8a5CF854791412c1f6EFC7CAf629f5Df1c747' // Polygon TestNet
    },
    usdt_token: {
        1: '0xdAC17F958D2ee523a2206206994597C13D831ec7', // Ethereum Mainnet
        4: '0x3B00Ef435fA4FcFF5C209a37d1f3dcff37c705aD', // Rinked TestNet
        5: '0xe802376580c10fE23F027e1E19Ed9D54d4C9311e', // Goerli TestNet
        137: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F', // Polygon MainNet
        80001: '0xA02f6adc7926efeBBd59Fd43A84f4E0c0c91e832' // Polygon TestNet
    }
}

export default addresses;